import { useContext, useState, useEffect } from "react";
import AuthContext from "../context/AuthContext";
import { useParams, useNavigate, useLocation, useMatch } from "react-router-dom";
import axiosInstance from "../api/axios";
import ConversationList from "../components/ConversationList";
import Conversation from "../components/Conversation";
import SearchBox from "../components/SearchBox";

export default function Messages() {
  const { token, user } = useContext(AuthContext);
  const { t_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [threadId, setThreadId] = useState(null);
  const [threads, setThreads] = useState([]);

  const match = useMatch(`/messages/t/:threadId`);

  const listThreads = async () => {
    try {
      // TODO: paginate threads list
      const res = await axiosInstance.get(`/chat/threads/`, {
        headers: { Authorization: `Token ${token}` },
      });
      const data = Array.isArray(res?.data) ? res.data : [];
      setThreads(
        data.filter(
          (t) =>
            t.id?.toString() == String(threadId) ||
            t.last_message != null ||
            t.last_message_at != null
        )
      );
    } catch (err) {
      console.error("Error fetching threads", err);
    }
  };

  useEffect(() => {
    if (t_id) {
      setThreadId(t_id);
    } else {
      setThreadId(null);
      navigate(`/messages/`);
    }
  }, [t_id]);

  useEffect(() => {
    listThreads();
  }, [token, threadId]);

  const ensureDM = async (partnerUsername) => {
    try {
      const { data } = await axiosInstance.post(
        `/chat/threads/ensure/`,
        { partner: partnerUsername },
        { headers: { Authorization: `Token ${token}` } }
      );
      setThreadId(data.id); // id
    } catch (err) {
      console.error("Error starting/fetching thread", err);
    }
  };

  useEffect(() => {
    // go to threadId when set
    if (threadId && (location.pathname === "/messages/" || location.pathname === "/messages")) {
      navigate(`/messages/t/${threadId}`);
    }
  }, [threadId]);

  // handles selected profile from search to start new thread
  const handleProfileSelect = (profile) => {
    ensureDM(profile.username);
  };

  return (
    <div className="flex-1 w-full h-full">
      <div className="relative flex h-full border rounded overflow-hidden">
        <ConversationList threads={threads} />
        <div className="flex-1 min-w-0 p-4">
          {match ? (
            <div className="flex flex-col h-full">
              <Conversation threadId={threadId} />
            </div>
          ) : (
            <div className="flex flex-col w-full items-center">
              <SearchBox onItemClick={handleProfileSelect} />
              <p className="text-gray-500">Select a conversation to view or start a new one</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
